import React, { createContext, useEffect, useState, useSyncExternalStore } from 'react';

import { SUPPORTED_LOCALES, getTranslationsSnapshot, loadMomentLocale, setLanguageMirror, subscribeToTranslationUpdates } from '@/utils/Language';
import { localStorageService } from '@/utils/local_storage';
import { getUrlParameter } from '@/utils/utils';

export const languageContext = createContext({ currentLanguage: 'en', setLanguage: () => {} });

export const LanguageProvider = ({ children }) => {
  const [currentLanguage, setCurrentLanguage] = useState('en');

  // Keep the module-level mirror in sync so withTranslations can read it synchronously.
  setLanguageMirror(currentLanguage);

  // Re-render when translation JSON files finish loading (language switch async load).
  useSyncExternalStore(subscribeToTranslationUpdates, getTranslationsSnapshot, getTranslationsSnapshot);

  const setLanguage = (newLang) => {
    const normalized = newLang || 'en';
    setCurrentLanguage(normalized);
    localStorageService.set('locale', normalized);
    loadMomentLocale(normalized);
  };

  useEffect(() => {
    const browserLang = getUrlParameter('locale') || localStorageService.get('locale') || navigator.language || navigator.userLanguage;
    let detected = 'en';
    if (SUPPORTED_LOCALES.includes(browserLang)) {
      detected = browserLang;
    } else {
      const base = browserLang?.split('-')[0];
      if (SUPPORTED_LOCALES.includes(base)) detected = base;
    }
    setLanguage(detected);
  }, []);

  return <languageContext.Provider value={{ currentLanguage, setLanguage }}>{children}</languageContext.Provider>;
};
